import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    // Log bootstrap errors instead of silently swallowing them
    // eslint-disable-next-line no-console
    console.error('Angular bootstrap error', err);

    // Best-effort attempt to hide native Cordova splash screen
    // even if Angular failed to bootstrap.
    try {
      const nav: any = navigator as any;
      if ((window as any).cordova && nav && nav.splashscreen && typeof nav.splashscreen.hide === 'function') {
        nav.splashscreen.hide();
      }
    } catch (hideError) {
      // eslint-disable-next-line no-console
      console.error('Failed to hide splashscreen after bootstrap error', hideError);
    }
  });